import axios, { AxiosInstance } from "axios";
interface AxiosConfig {
  baseURL?: string;
  headers?: Record<string, string>;
}

export const axiosConfigBuilder = (config: AxiosConfig = {}) => {
  const setBaseUrl = (baseURL?: string) => {
    const APP_BASE_URL = process.env.REACT_APP_BASE_URL;

    if (!baseURL) {
      baseURL = APP_BASE_URL;
    }

    return axiosConfigBuilder({ ...config, baseURL });
  };

  const setHeaders = (headers: Record<string, string>) => {
    return axiosConfigBuilder({
      ...config,
      headers: { ...config.headers, ...headers },
    });
  };

  const build = (): AxiosInstance => {
    const instance = axios.create(config);

    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem("_accessToken");
          window.location.href = "/login?source=ExpiredToken";
        }

        return Promise.reject(error);
      }
    );

    return instance;
  };

  return {
    setBaseUrl,
    setHeaders,
    build,
  };
};
